import { GridOptionsContext } from '@contexts/grid-options'
import { ContentType } from '@entries/content-types'
import ContentfulContentArticle from '@entries/contentful-content-article'
import ContentfulFaqPageList from '@entries/contentful-faq-page-list'
import ContentfulGraphs from '@entries/contentful-graphs'
import ContentfulReview from '@entries/contentful-review'
import ContentfulRightLeftTextWithImage from '@entries/contentful-right-left-text-with-image'
import ContentfulShortContentBlock from '@entries/contentful-short-content-block'
import ContentfulStaticBlock from '@entries/contentful-static-block'
import ContentfulWrapperRichMedia from '@entries/contentful-wrapper-rich-media'
import ContentfulYoutubePlayer from '@entries/contentful-youtube-player'
import { withDisplayName } from '@hocs/with-display-name'
import { Entry } from '@resolvers/entry'
import { ContentfulContentArticleTemplate } from '@typings/contentful-content-article-template'
import { clsx } from 'clsx'
import { graphql } from 'gatsby'
import React, { useContext } from 'react'

import contentfulMultipleNumberHighlight from './contentful-multiple-number-highlight'

const ContentfulPageSectionGridLayout: Utils.EntryFC<
  Queries.ContentfulPageSectionGridLayoutFragment
> = ({
  content: { contents, contentArticleTemplate },
  entryInspectorProps,
  fieldInspectorProps,
}) => {
  const {
    col: { mobileS = 1, mobileM, mobileL, tablet, laptop, laptopL, desktop },
  } = useContext(GridOptionsContext)
  return (
    <div
      className={clsx(
        contentArticleTemplate ===
          ContentfulContentArticleTemplate.REFRESH_DEFAULT
          ? 'gap-32'
          : 'gap-6',
        `grid items-stretch`,
        `grid-cols-${mobileS}`,
        mobileM && `mobileM:grid-cols-${mobileM}`,
        mobileL && `mobileL:grid-cols-${mobileL}`,
        tablet && `tablet:grid-cols-${tablet}`,
        laptop && `laptop:grid-cols-${laptop}`,
        laptopL && `laptopL:grid-cols-${laptopL}`,
        desktop && `desktop:grid-cols-${desktop}`
      )}
      {...entryInspectorProps()}
      {...fieldInspectorProps({
        fieldId: 'contents',
      })}
    >
      {contents?.map((item: any, i: number) => (
        <Entry
          key={`grid-item-${item.id}-${i}`}
          content={item}
          mapping={{
            [ContentType.ContentfulContentArticle]: ContentfulContentArticle,
            [ContentType.ContentfulGraph]: ContentfulGraphs,
            [ContentType.ContentfulStaticBlock]: ContentfulStaticBlock,
            [ContentType.ContentfulWrapperRichMedia]:
              ContentfulWrapperRichMedia,
            [ContentType.ContentfulReview]: ContentfulReview,
            [ContentType.ContentfulFaqPageList]: ContentfulFaqPageList,
            [ContentType.ContentfulMultipleNumberHighlight]:
              contentfulMultipleNumberHighlight,
            [ContentType.ContentfulRightLeftTextWithImage]:
              ContentfulRightLeftTextWithImage,
            [ContentType.ContentfulYoutubePlayer]: ContentfulYoutubePlayer,
            [ContentType.ContentfulShortContentBlock]:
              ContentfulShortContentBlock,
          }}
        />
      ))}
    </div>
  )
}

export const query = graphql`
  fragment ContentfulPageSectionGridLayout on ContentfulSection {
    ...ContentfulEntry
    contentArticleTemplate
    contents {
      ...ContentfulContentArticle
      ...ContentfulStaticBlock
      ...ContentfulWrapperRichMedia
      ...ContentfulReview
      ...ContentfulFaqPageList
      ...ContentfulGraphs
      ...ContentfulNumbersHighlight
      ...ContentfulRightLeftTextWithImage
      ...ContentfulYoutubePlayer
      ...ContentfulShortContentBlock
    }
  }
`

export default withDisplayName(
  ContentfulPageSectionGridLayout,
  'ContentfulPageSectionGridLayout'
)
